import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/client';

export class ClientService extends RestServiceConnection {

    listClients = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    getClientById = async (clientId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { clientId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    toggleClientState = async (clientId: string, status: boolean) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle',
            data: { clientId, active: status },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    createClient = async (entity: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: entity,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    editClient = async (entity: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: entity,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    deleteClient = async (clientId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { clientId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    deleteMultiClients = async (clientIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-multi',
            data: { clientIds },
        }, true);
        return this;
    }

    listComments = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-comments',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    addComment = async (clientId: string, comment: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/add-comment',
            data: { clientId, comment },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    editComment = async (commentId: string, comment: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit-comment',
            data: { commentId, comment },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    deleteComment = async (clientCommentId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-comment',
            data: { clientCommentId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    deleteMultiComments = async (clientCommentIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/multi-delete-comment',
            data: { clientCommentIds },
        }, true);
        return this;
    }

    lisStudents = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-students',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    // TODO: Not used in the frontend
    listProducts = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-products',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    listContracts = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-contracts',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    getConsultancy = async (clientId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get-consultancy',
            data: { clientId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    listInvoices = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-invoices',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    listInvoicesDueDates = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-invoices-due-dates',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    listCalls = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-calls',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    listCreditsUpdate = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-credits-update',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    previewAddCredits = async (
        clientId: string,
        credits: number,
        startDate: string,
        endDate: string,
        fundaeGroupingId?: string,
        contractIds?: string[],
        excludeClientCreditId?: string
    ) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/preview-add-credits',
            data: { clientId, credits, startDate, endDate, fundaeGroupingId, contractIds, excludeClientCreditId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    addCredits = async (
        clientId: string,
        credits: number,
        startDate: string,
        endDate: string,
        sendIncidenceEmails: boolean = false,
        fundaeGroupingId?: string,
        contractIds?: string[],
        documents: File[] = []
    ) => {
        const formData = new FormData();
        formData.append('clientId', clientId);
        formData.append('credits', String(credits));
        formData.append('startDate', startDate);
        formData.append('endDate', endDate);
        formData.append('sendIncidenceEmails', sendIncidenceEmails ? '1' : '0');

        if (fundaeGroupingId) {
            formData.append('fundaeGroupingId', fundaeGroupingId);
        }

        contractIds?.forEach((contractId) => {
            formData.append('contractIds[]', contractId);
        });

        documents.forEach((document) => {
            formData.append('documents[]', document);
        });

        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/add-credits',
            data: formData,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }

    editCreditsUpdate = async (
        clientCreditId: string,
        credits: number,
        sendIncidenceEmails: boolean = false,
        contractIds?: string[]
    ) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit-credits-update',
            data: { clientCreditId, credits, sendIncidenceEmails, contractIds },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    addCreditsUpdateDocuments = async (clientCreditId: string, documents: File[]) => {
        const formData = new FormData();
        formData.append('clientCreditId', clientCreditId);
        documents.forEach((document) => {
            formData.append('documents[]', document);
        });

        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/add-credits-update-documents',
            data: formData,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }

    deleteCreditsUpdateDocument = async (clientCreditId: string, documentId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-credits-update-document',
            data: { clientCreditId, documentId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    listActivityHistory = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-activity-history',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    generateInvoicePdf = async (invoiceId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/generate-client-invoice-pdf',
            data: { invoiceId },
            responseType: 'arraybuffer', // to avoid string conversion
        }, true);
        return this;
    }

    sendClientEmail = async (data: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/send-client-email',
            data: data,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    listClientCommercialNetworks = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-client-commercial-networks',
            data: filters,
        }, true);
        return this;
    }

    addClientCommercialNetwork = async (data: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/add-commercial-network',
            data: data,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    removeClientCommercialNetwork = async (data: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/remove-commercial-network',
            data: data,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

}
